/** Formatação da casa. Data e número em pt-BR, sempre. */
export const dataHora = (d: Date | string | null | undefined): string => {
  if (!d) return "sem data";
  const data = typeof d === "string" ? new Date(d) : d;
  return data.toLocaleString("pt-BR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const dataCurta = (d: Date | string | null | undefined): string => {
  if (!d) return "sem data";
  const data = typeof d === "string" ? new Date(d) : d;
  return data.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

/** Tempo dentro da gravação, para o trecho de evidência. */
export const marcaDeTempo = (ms: number): string => {
  const s = Math.floor(ms / 1000);
  const m = Math.floor(s / 60);
  return `${String(m).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

export const duracao = (segundos: number | null | undefined): string => {
  if (!segundos) return "sem duração";
  const m = Math.round(segundos / 60);
  return m >= 60 ? `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}` : `${m} min`;
};

export const reais = (centavos: number): string =>
  (centavos / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Valor ausente é "sem registro", nunca travessão (regra de voz da casa). */
export const ouSemRegistro = (v: string | null | undefined): string => v?.trim() || "sem registro";
